//
// COOKIE ALERT
//
const storage = window.localStorage;
const cookieAlertEl = document.getElementById('cookieAlert');

if (cookieAlertEl) {
  const cookieAlertCloseEl = document.getElementById('cookieAlertClose');

  if (!storage.getItem('cookieAccepted') || storage.getItem('cookieAccepted') !== '1') {
    cookieAlertEl.style.display = 'block';
  } else {
    acceptCookie();
  }

  cookieAlertCloseEl.addEventListener('click', (e) => {
    e.preventDefault();
    storage.setItem('cookieAccepted', '1');
    acceptCookie();
  });

  window.addEventListener('storage', ({ key, newValue }) => {
    if (key === 'cookieAccepted' && newValue === '1') {
      acceptCookie();
    }
  });

  function acceptCookie() {
    cookieAlertEl.style.display = 'none';
    window.enableGTM();
  }
}
